import { Component, OnInit } from '@angular/core';
import { LookupSource } from '../../../core/models/lookup-source.model';
import { LookupSourceService } from '../../../core/services/lookup-source.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
      selector: 'app-lookup-manager',
      imports: [CommonModule, FormsModule],
      templateUrl: './lookup-manager.component.html'
})
export class LookupManagerComponent implements OnInit {
      sources: LookupSource[] = [];
      filteredSources: LookupSource[] = [];
      searchTerm: string = '';

      // Pagination
      pageIndex: number = 0;
      pageSize: number = 10;
      totalCount: number = 0;

      isModalOpen: boolean = false;
      currentSource: LookupSource = this.getEmptySource();

      constructor(private service: LookupSourceService) { }

      ngOnInit(): void { this.loadData(); }

      getEmptySource(): LookupSource {
            return {
                  code: '', name: '', tableName: '', valueField: 'id',
                  labelField: 'name', searchFields: '',
                  staticFilters: '',
                  sortField: 'name', sortDir: 'asc', isActive: true
            };
      }

      loadData(): void {
            this.service.getAll(this.pageIndex, this.pageSize, this.searchTerm)
                  .subscribe(res => {
                        this.sources = res.items;
                        this.totalCount = res.totalCount;
                  });
      }

      // filterData(): void {
      //       const term = this.searchTerm.toLowerCase();
      //       this.filteredSources = this.sources.filter(s =>
      //             s.name.toLowerCase().includes(term) || s.code.toLowerCase().includes(term)
      //       );
      //       this.pageIndex = 0;
      // }
      onSearch(): void {
            this.pageIndex = 0; // Reset to page 1 on search
            this.loadData();
      }
      changePage(index: number): void {
            this.pageIndex = index;
            this.loadData();
      }

      changePageSize(): void {
            this.pageIndex = 0;
            this.loadData();
      }
      get startRange() { return this.pageIndex * this.pageSize + 1; }
      get endRange() { 
        const end = (this.pageIndex + 1) * this.pageSize;
        return end > this.totalCount ? this.totalCount : end;
    }
      get totalPages() { return Math.ceil(this.totalCount / this.pageSize); }

      // Logic to show only the current page
      get paginatedSources() {
            const start = this.pageIndex * this.pageSize;
            return this.filteredSources.slice(start, start + this.pageSize);
      }

      openModal(source?: LookupSource): void {
            this.currentSource = source ? { ...source } : this.getEmptySource();
            this.isModalOpen = true;
      }


      save(): void {
            this.service.save(this.currentSource).subscribe(() => {
                  this.isModalOpen = false;
                  this.loadData();
            });
      }

      delete(id?: string): void {
            if (id && confirm('Delete this source?')) {
                  this.service.delete(id).subscribe(() => this.loadData());
            }
      }
}